export const dbKeyAllFlights = 'allFlightsDB';
export const dbKeySelectedFlight = 'selectedFlightDB';
export const dbKeyLastCacheTimestamp = 'lastCacheTimestampDB';
export const dbKeyCacheResetTimestamp = 'cacheResetTimestampDB';
export const dbKeyAreaMessages = 'areaMessagesDB';
export const dbKeyPreFlightBriefing = 'preFlightBriefingDB';
export const dbKeyTimestamp = (flight) => 'timestampDB' + flight;
export const dbKeyFlightData = (flight) => 'flightDataDB' + flight;
export const dbKeyAirportSelected = (flight) => 'airportSelectedDB' + flight;
export const dbKeyReqFuel = (flight) => 'reqFuelDB' + flight;
export const dbKeyAirports = (flight) => 'airportsDB' + flight;
export const dbKeyCIF = (flight) => 'CIFDB' + flight;
export const dbKeyCTOT = (flight) => 'CTOTDB' + flight;
export const dbKeyCTOTCrew = (flight) => 'CTOTCrewDB' + flight;
export const dbKeyCTOTAck = (flight) => 'CTOTAckDB' + flight;
export const dbKeyMETAR = (flight) => 'METARDB' + flight;
export const dbKeySNOWTAM = (flight) => 'SNOWTAMDB' + flight;
export const dbKeyTAF = (flight) => 'TAFDB' + flight;
export const dbKeyNOTAM = (flight) => 'NOTAMDB' + flight;
export const dbKeyNOTAMByICAO = (icao) => 'NOTAMDB_ICAO_' + icao.toUpperCase();
export const dbKeyFlightInfoCrew = (flight) => 'flightInfoCrewDB' + flight;
export const dbKeyTkofSettings = (ACReg) => 'tkofSettings' + ACReg;
export const dbKeyWXGImages = (flight) => 'wxgImagesDB' + flight;
export const dbKeyDMSFiles = (flight) => 'dmsFilesDB' + flight;
export const dbKeyOFPFiles = (flight) => 'ofpFilesDB' + flight;
export const dbKeyPassengerList = (flight) => 'passengerListDB' + flight;
export const dbKeySeatmap = (flight) => 'seatmapDB' + flight;
export const dbKeyMealMode = (flight) => 'mealModeDB' + flight;
export const dbKeyColdSoak = (flight) => 'coldSoakDB' + flight;
export const dbKeyBagList = (flight) => 'bagListDB' + flight;
